import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../../lib/shared/validators";

// Tipos de documentos de exención fiscal
export const exemptDocumentTypes = v.union(
  v.literal("tax_exemption_certificate"), // Constancia de exención
  v.literal("exempt_purchase_order"), // Orden de compra exenta
  v.literal("diplomatic_exemption"), // Exención diplomática
  v.literal("ngo_exemption"), // Exención ONG
  v.literal("other"), // Otros tipos personalizados
);

export const exemptInvoiceConfigurationValidator = v.object({
  type: exemptDocumentTypes,
  title: v.string(),
  description: v.string(),
  isEnabled: v.boolean(), // Si este documento está activo en la configuración
  isRequired: v.boolean(), // Si es obligatorio cuando está habilitado
  requiresFiscalCode: v.boolean(), // Si debe tener código fiscal
  fiscalCodeLabel: v.optional(v.string()), // Ej: "CAI", "Número de Constancia"
  fiscalCodePattern: v.optional(v.string()), // Regex para validar formato
  requiresAttachment: v.boolean(), // Si debe subir archivo
  allowedFileTypes: v.optional(v.array(v.string())), // ["pdf", "jpg", "png"]
  maxFileSizeMB: v.optional(v.number()),
  requiresExpiryDate: v.boolean(), // Si tiene fecha de vencimiento
  printOnInvoice: v.boolean(), // Si se imprime en la factura
  printLabel: v.optional(v.string()), // Texto a imprimir
  validationRules: v.optional(
    v.object({
      minLength: v.optional(v.number()),
      maxLength: v.optional(v.number()),
      allowedCharacters: v.optional(v.string()), // Ej: "alphanumeric", "numeric"
    }),
  ),
  metadata: v.optional(v.record(v.string(), v.any())), // Campos adicionales personalizados
  internalControl,
});

export const invoices_configuration_exempts = defineTable(
  exemptInvoiceConfigurationValidator,
)
  .index("by_company_id", ["internalControl.companyId"]) // Relación con empresas
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
